const a={block:"block","inline-block":"inline-block"},o={featured:"featured",primary:"primary"};export{a as themes,o as variants};
//# sourceMappingURL=flag.types.js.map
